import { Injectable } from '@angular/core';
import { Request } from '@core/models/requests.model';
import { Autos } from '@core/interfaces/catalogos.intefaces';

@Injectable({
  providedIn: 'root'
})
export class AutosFlotillasService {
  private url = `ventas/catalogos/flotillas/auto/search`;

  constructor(private request: Request) {}

  getAutos (body:any) {
    const options = { headers: this.request.headers };
    return this.request.Post<Autos>(this.url,body, options);
  }
}
